import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BreadcrumbComponent } from './breadcrumb.component';

// BreadcrumbComponent (<app-breadcrumb>) is used by ~30 components across the
// app - both ones staying in HomeModule and ones being extracted into their
// own lazy modules (starting with ListingDetailsModule). Giving it its own
// module lets every consumer import it independently without needing
// HomeModule itself, which would defeat lazy loading entirely.
@NgModule({
  declarations: [BreadcrumbComponent],
  imports: [CommonModule],
  exports: [BreadcrumbComponent],
})
export class BreadcrumbModule {}
